<template>
  <div class="app-container">
    <el-tabs @tab-click="handleClick" v-model="activeName">
      <el-tab-pane
        :label="item.name"
        :name="item.id"
        v-for="(item, index) in qiyeList"
        :key="index + 'qiye'"
      ></el-tab-pane>
    </el-tabs>
    <div class="toolbar">
      <el-form :model="queryParams" ref="queryForm" size="small" :inline="true">
        <el-form-item label="所属部门" prop="deptId">
          <el-select style="width: 100%" v-model="queryParams.deptId" placeholder="请选择所属部门" clearable filterable>
            <el-option
              v-for="item in deptList"
              :key="item.deptId + 'deptId'"
              :label="item.deptName"
              :value="item.deptId"
              v-show="item.parentId != 0 && item.parentId != 100"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="提交时间" prop="createTime">
          <el-date-picker v-model="queryParams.createTime" type="date" placeholder="选择日期" value-format="yyyy-MM-dd">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="提交人" prop="name">
          <el-input
            v-model="queryParams.name"
            placeholder="请输入提交人"
            clearable
            @keyup.enter.native="handleQuery('up')"
          />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" size="mini" @click="handleQuery('up')">搜索</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="table-list">
      <el-table :data="tableData.list" stripe height="450" :size="size">
        <el-table-column prop="companyName" label="所属公司" width="150" show-overflow-tooltip />
        <el-table-column prop="headImgUrl" label="头像" width="120" show-overflow-tooltip>
          <template slot-scope="{ row }">
            <image-preview :src="row.headImgUrl" :width="40" :height="40"></image-preview>
          </template>
        </el-table-column>
        <el-table-column prop="name" label="提交人" width="150" show-overflow-tooltip />
        <el-table-column prop="completedWork" label="今日完成工作" width="150" show-overflow-tooltip />
        <el-table-column prop="unfinishedWork" label="未完成工作" width="150" show-overflow-tooltip />
        <el-table-column prop="needCoordinationWork" label="需协调工作" width="150" show-overflow-tooltip />
        <el-table-column prop="workPlan" label="明日工作计划" width="150" show-overflow-tooltip />
        <el-table-column prop="picture" label="照片" width="120" show-overflow-tooltip>
          <template slot-scope="{ row }">
            <image-preview :src="row.picture" :width="40" :height="40"></image-preview>
          </template>
        </el-table-column>
        <el-table-column prop="createTime" label="提交时间" minwidth="150" show-overflow-tooltip />
        <el-table-column label="操作" fixed="right" width="150">
          <template slot-scope="scope">
            <el-button icon="el-icon-search" circle size="mini" @click="handleDetail(scope.row)" />
            <el-button type="danger" size="mini" @click="handleDelete(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="toolbar" style="padding: 10px" v-if="tableData.total > 0">
        <pagination
          :total="tableData.total"
          :page.sync="queryParams.pageNum"
          :limit.sync="queryParams.pageSize"
          @pagination="handleQuery"
        />
      </div>
    </div>
    <el-drawer title="详情" :visible.sync="openDrawer" destroy-on-close class="editdrawer OA" size="32%">
      <div class="xiangqing">
        <el-form
          :model="form"
          label-width="120px"
          ref="form"
          label-position="left"
          style="margin-bottom: 45px"
          :disabled="true"
        >
          <el-form-item label="所属公司" prop="companyName">
            <el-input v-model="form.companyName" placeholder="所属公司" />
          </el-form-item>
          <el-form-item label="头像" prop="headImgUrl">
            <div v-if="form.headImgUrl">
              <image-preview :src="form.headImgUrl" :width="50" :height="50"></image-preview>
            </div>
          </el-form-item>
          <el-form-item label="提交人" prop="name">
            <el-input v-model="form.name" placeholder="提交人" />
          </el-form-item>
          <el-form-item label="今日完成工作" prop="completedWork">
            <el-input v-model="form.completedWork" type="textarea" autosize placeholder="今日完成工作" />
          </el-form-item>
          <el-form-item label="未完成工作" prop="unfinishedWork">
            <el-input v-model="form.unfinishedWork" type="textarea" autosize placeholder="未完成工作" />
          </el-form-item>
          <el-form-item label="需协调工作" prop="needCoordinationWork">
            <el-input v-model="form.needCoordinationWork" type="textarea" autosize placeholder="需协调工作" />
          </el-form-item>
          <el-form-item label="明日工作计划" prop="needCoordinationWork">
            <el-input v-model="form.needCoordinationWork" type="textarea" autosize placeholder="明日工作计划" />
          </el-form-item>
          <el-form-item label="照片" prop="picture">
            <div v-if="form.picture">
              <div
                v-for="(item, index) in form.picture.split(',')"
                :key="index + 'aaa'"
                style="float: left;margin:5px;"
              >
                <image-preview :src="item" :width="50" :height="50"></image-preview>
              </div>
            </div>
            <div v-else>未上传</div>
          </el-form-item>
          <el-form-item label="附件" prop="attachments">
            <div v-if="form.attachments">
              <div v-for="(item, index) in form.attachments.split(',')" :key="index + 'bbb'">
                <el-link :href="item" target="_blank"
                  >附件{{ index + 1 }}<i class="el-icon-view el-icon--right"></i>
                </el-link>
              </div>
            </div>
            <div v-else>未上传</div>
          </el-form-item>
          <el-form-item label="提交时间" prop="createTime">
            <el-input type="textarea" autosize v-model="form.createTime" placeholder="提交时间" />
          </el-form-item>
        </el-form>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import { workLogList, workLogDelete } from '@/api/clockIn'
import axios from 'axios'
export default {
  name: '',
  data() {
    return {
      url: this.$route.query.url,
      size: 'mini',
      loading: false,
      openDrawer: false,
      activeName: '',
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        name: null,
        createTime: null,
        deptId: undefined,
        // companyId: this.$route.query.EId,
        platformId: this.$route.query.platformId,
      },
      tableData: {},
      form: {},
      deptList: [],
      qiyeList: [],
    }
  },
  mounted() {
    this.getQiyeList()
    // this.handleQuery()
  },
  methods: {
    // 获取企业列表
    getQiyeList() {
      if (this.$route.query.EId == 'null') {
        var EId = null
      } else {
        var EId = this.$route.query.EId
      }
      axios({
        url: this.url + '/system/company/listOut',
        method: 'get',
        params: {
          platformId: this.$route.query.platformId,
          id: EId,
          pageSize: 999,
        },
      }).then((res) => {
        if (res.data.code  == 200) {
          this.activeName = res.data.rows[0].id
          this.qiyeList = res.data.rows
          this.getDeptList(this.activeName)
          this.queryParams.companyId = this.activeName
          this.handleQuery()
        }
      })
    },
    // 企业切换
    handleClick(e) {
      this.queryParams.deptId = null
      this.getDeptList(e.name)
      this.queryParams.companyId = e.name
      this.handleQuery()
    },
    getDeptList(companyId) {
      axios({
        url: this.url + '/system/dept/list',
        method: 'get',
        params: {
          platformId: this.$route.query.platformId,
          companyId: companyId,
          pageSize: 999,
        },
      }).then((res) => {
        if (res.data.code == 200) {
          this.deptList = res.data.data
        }
      })
    },
    // 查询
    handleQuery(part) {
      if (part == 'up') {
        this.queryParams.pageNum = 1
      }
      workLogList(this.queryParams).then((res) => {
        if (res.code == 200) {
          this.tableData = res.data
        }
      })
    },
    // 详情
    handleDetail(row) {
      this.openDrawer = true
      this.form = Object.assign({}, row)
    },
    // 删除
    handleDelete(row) {
      this.$confirm('确认要删除此项吗？', '提示', {}).then(() => {
        workLogDelete({ id: row.id }).then((res) => {
          if (res.code === 200) {
            this.$message({ message: '删除成功', type: 'success' })
            this.handleQuery()
            this.$refs['form'].resetFields()
          } else {
            this.$message({ message: '删除失败, ' + res.msg, type: 'error' })
          }
        })
      })
    },
  },
}
</script>
<style lang="less" scoped></style>
